/* eslint-disable rxjs-x/finnish */
import { AlertSeverityStoreModelEnum } from '@domain/alerting/alerting.enums';

import { TableStatusCellProperties } from '@shared/components/table-status-cell';
import { TranslateAlertSeverityPipe } from '@shared/pipes/translate-enum-pipes/translate-alert-severity.pipe';

export const getAlertSeverityTableStatusCellProperties = (
  translateAlertSeverityPipe: TranslateAlertSeverityPipe
): TableStatusCellProperties<AlertSeverityStoreModelEnum> => ({
  [AlertSeverityStoreModelEnum.Info]: {
    bgColorClass: 'bg-status-info',
    dropShadowClass: 'drop-shadow-status-info-shadow-30',
    label: translateAlertSeverityPipe.transform$(AlertSeverityStoreModelEnum.Info),
  },
  [AlertSeverityStoreModelEnum.Warning]: {
    bgColorClass: 'bg-status-warning',
    dropShadowClass: 'drop-shadow-status-warning-shadow-30',
    label: translateAlertSeverityPipe.transform$(AlertSeverityStoreModelEnum.Warning),
  },
  [AlertSeverityStoreModelEnum.Critical]: {
    bgColorClass: 'bg-status-error',
    dropShadowClass: 'drop-shadow-status-error-shadow-30',
    label: translateAlertSeverityPipe.transform$(AlertSeverityStoreModelEnum.Critical),
  },
});
